import { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Toast, ToastContainer } from "react-bootstrap";
import { ClipboardFill, Link45deg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { getWebsiteUrl } from "../../../functions/endpoint";
import { disableLink, generateLink, getLink } from "../../../functions/gameLink";
import '../../../components/home/Home.css';

const PUBLIC_GAMES_PATH = "/public/games";

function GameLink({ token, onError }) {
    const { t } = useTranslation('messages');

    const [gameLinkActive, setGameLinkActive] = useState(false);
    const [gameLink, setGameLink] = useState("");
    const [showCopyToast, setShowCopyToast] = useState(false);

    useEffect(() => {
        getLink(token, (data) => {
            setGameLink(buildGameLinkUrl(data.enabled, data.gameLinkId));
            setGameLinkActive(data.enabled);
        }, onError);
    }, [token, onError]);

    return (
        <>
            <Container fluid className="home-hero text-white">
                <Container className="py-5 position-relative" style={{ zIndex: 1 }}>
                    <h1 className="display-5 fw-bold mb-4">{t('private_area.game_link_tab.link_title')}</h1>
                    <Row>
                        <Col xs={12} md={8} lg={6}>
                            <Form.Check
                                type="switch"
                                id="game-link-switch"
                                label={t('private_area.game_link_tab.switch_label')}
                                checked={gameLinkActive}
                                onChange={(e) => onSetGameLinkClicked(token, e.target.checked, setGameLinkActive, setGameLink, onError)}
                                className="text-white mb-3"
                            />
                            <InputGroup size="lg">
                                <InputGroup.Text className="border-0 bg-white">
                                    <Link45deg size={18} className="text-muted" />
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    value={gameLink}
                                    readOnly
                                    disabled={!gameLink}
                                    placeholder={gameLinkActive ? "" : "—"}
                                    className="border-0"
                                />
                                <Button
                                    variant="light"
                                    className="fw-semibold"
                                    onClick={() => onCopyAllClicked(gameLink, setShowCopyToast)}
                                    disabled={!gameLink}>
                                    <ClipboardFill size={14} className="me-2" />
                                    {t('private_area.game_link_tab.copy_all_button_text')}
                                </Button>
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <ToastContainer position="bottom-end" className="p-3">
                <Toast
                    onClose={() => setShowCopyToast(false)}
                    show={showCopyToast}
                    delay={2000}
                    autohide
                    bg="dark">
                    <Toast.Body className="text-white">
                        {t('private_area.game_link_tab.link_copied_toast_text')}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
}

function onCopyAllClicked(gameLink, setShowCopyToast) {
    navigator.clipboard.writeText(gameLink);
    setShowCopyToast(true);
}

function buildGameLinkUrl(enabled, gameLinkId) {
    if (enabled) {
        return getWebsiteUrl() + PUBLIC_GAMES_PATH + "?game_link_id=" + gameLinkId;
    }
    return "";
}

function onSetGameLinkClicked(token, checked, setGameLinkActive, setGameLink, onError) {
    if (checked) {
        generateLink(token, (data) => {
            setGameLink(buildGameLinkUrl(true, data.gameLinkId));
            setGameLinkActive(true);
        }, onError);
    } else {
        disableLink(token, () => {
            setGameLink("");
            setGameLinkActive(false);
        }, onError);
    }
}

export default GameLink;
